// extracted by mini-css-extract-plugin
export var footer = "_pb-5";
export var fulfillmentInput = "_pb-0";
export var shipDateInput = "_pb-1";
export var shipmentModal = "_pb-2";
export var shipmentModalContent = "_pb-3";
export var tableContainer = "_pb-4";